import Com from "components/styledComp/CommStyledComp";
import React from "react";

const CompImg = ({img, width= "100%", height="100%", fit = "cover", alt = ""}) => {
  if (fit === "contain") {
    return (
      <Com.ContainImg src={img} alt={alt} width={width} height={height}/>
    );
  }

  return (
    <Com.MiddleImg src={img} alt={alt} width={width} height={height}/>
  );
};

export default CompImg;
